import { useParams } from 'react-router-dom'
import Modal, {
  ModalBody,
  ModalHeader,
} from '../../../../../../components/common/Modal'
import SelectInput from '../../../../../../components/common/SelectInput'
import { getRequest } from '../../../../../../services/base'
import { useContext, useEffect, useState } from 'react'
import useDebouncedValue from '../../../../../../utils/common_function'
import Button from '../../../../../../components/common/Button'
import {
  DtcDependencyContext,
  SHOW_DEPENDENCY_MODAL,
} from '../../context/context'

const DtcDependencyForm = (props) => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(DtcDependencyContext)
  const [options, setOptions] = useState([])
  const [searchDtc, setSearchDtc] = useState('')
  const debouncedSearchTerm = useDebouncedValue(searchDtc, 1000)

  useEffect(() => {
    getDtcsData()
  }, [])

  useEffect(() => {
    getDtcsData(debouncedSearchTerm)
  }, [debouncedSearchTerm])

  const getDtcsData = async (search = '') => {
    let res = await getRequest(`/api/dtcs/?vehicle=${vehicle}&search=${search}`)
    setOptions(res.results)
  }

  const dtcFilterOptions = (option, searchText) => {
    if (
      option.data.name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.description
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      option.data.ecu.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true
    } else {
      return false
    }
  }

  return (
    <Modal
      show={state.show_dependency_modal}
      onClose={() => {
        dispatch({ type: SHOW_DEPENDENCY_MODAL, data: false })
      }}
    >
      <ModalHeader className={'text-white'}>Add Dependencies</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            props.SubmitDependentDtc(e)
          }}
        >
          <SelectInput
            isMulti={true}
            label="Select Dependent DTC"
            className={`cursor-pointer py-2 pt-8 w-3/4`}
            options={options}
            onInputChange={(value) => {
              setSearchDtc(value)
            }}
            formatOptionLabel={(option) => (
              <>
                <div className="font-extrabold">
                  {option.name} ({option.ecu})
                </div>
                <div>
                  <span>{option.description}</span>
                </div>
              </>
            )}
            optionLabel={'name'}
            optionValue={'id'}
            filterOption={dtcFilterOptions}
            name="dtcs"
          />
          <div className="flex justify-end">
            <Button
              type="submit"
              className={`cursor-pointer cursor-pointer btn my-4 px-5`}
              onClick={(e) => {}}
              value={'text'}
              text="Save Dependency"
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default DtcDependencyForm
